/* eslint-disable */

import React from 'react';
import { Routes, Route } from 'react-router-dom';

import OrderPaySlip from './OrderPaySlip.js';
import OrderRefund from './OrderRefund.js';
import OrderIncome from './OrderIncome.js';
import OrderTracking from './OrderTracking.js';

function Order(props) {
  return (
    <Routes>
      <Route
        path='/payslip'
        element={
          <OrderPaySlip
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            isMobile={props.isMobile}
          />
        }
      />
      <Route
        path='/refund'
        element={
          <OrderRefund
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            isMobile={props.isMobile}
          />
        }
      />
      <Route
        path='/income'
        element={
          <OrderIncome
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            isMobile={props.isMobile}
          />
        }
      />
      <Route
        path='/tracking'
        element={
          <OrderTracking
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
            isMobile={props.isMobile}
          />
        }
      />
    </Routes>
  );
}

export default Order;
